module.exports = __webpack_public_path__ + "img/02-02-img-04@2x.0d3a6647.png";